export const getFilename = (inputValues, isFS, product) => {
  //* does this function get used?
  console.log(
    `Utilities script, getFilename(), when and where does this get used, if at all? does it conflict with the Filename.js script? \n`,
    "inputValues = ",
    inputValues
  );
  const clientName = inputValues.client;
  const duration = inputValues.duration;
  const desc = inputValues.campaign;
  const countryCode = inputValues.countryCode;
  const eORl = inputValues.platform === "elevator" ? "e" : "l";
  const fsValue = isFS ? "_fs" : "";

  // try {
  //   setBlankFilename(
  //     `${clientName}_${duration}_${product}blank_${countryCode}${fsValue}_${eORl}-${product}`
  //   );
  // } catch {
  //   console.log("not yet");
  // }

  return `${clientName}_${duration}_${desc}_${countryCode}${fsValue}_${eORl}-${product}`;
};

export function getManifestFile(
  noBintImages,
  filename,
  isElevator,
  mediaExtensions,
  partner
) {
  //* no CSS here, do not modify filename

  const filenameString = filename ? filename.toString() : "";
  const videoOrImageE = mediaExtensions.elevator === "mp4" ? "video" : "image";
  const videoOrImageL = mediaExtensions.landscape === "mp4" ? "video" : "image";
  const videoOrImageP = mediaExtensions.portrait === "mp4" ? "video" : "image";
  const ifPartner =
    typeof partner === "string" && partner ? partner.toLowerCase() + "/" : "";

  const filePathNameForProgOrDirect = partner
    ? partner.toLowerCase() + "/" + filename
    : filename; //* effectivly switches between either "filename" or "partnerFolder/filename"
  console.log(
    `Utilities script, reference filename[${filename}] to add the partner folder, if there is one, which gives us: filePathNameForProgOrDirect[${filePathNameForProgOrDirect}].`
  );

  console.log(
    "for the manifest why are we not geting a partner name? partner:",
    partner,
    "and what is ifPartner:",
    ifPartner
  );
  const svgManifestEntry = filenameString.includes("-fsbi")
    ? `,"advertising/${filePathNameForProgOrDirect}.svg"`
    : "";

  let mediaManifestEntry = "";
  if (!noBintImages) {
    mediaManifestEntry = isElevator
      ? `"advertising/${filePathNameForProgOrDirect}_e${videoOrImageE}.${mediaExtensions.elevator}"`
      : `"advertising/${filePathNameForProgOrDirect}_l${videoOrImageL}.${mediaExtensions.landscape}" ,"advertising/${filePathNameForProgOrDirect}_p${videoOrImageP}.${mediaExtensions.portrait}"`;
  }

  return `{
        "html": "advertising/${filePathNameForProgOrDirect}.html",
        "fonts": [],
        "images": [${mediaManifestEntry} ${svgManifestEntry}]
    }`;
}

export function getBlankHTML(blankFilename, partner) {
  //* effectivly switches between either "blankFilename" or "partnerFolder/blankFilename"
  const filePathNameForProgOrDirect = partner
    ? partner.toLowerCase() + "/" + blankFilename
    : blankFilename;

  console.log(
    `Utilities script, reference blankFilename[${blankFilename}] to add the partner folder, if there is one, which gives us: filePathNameForProgOrDirect[${filePathNameForProgOrDirect}].`
  );

  //* We are making CSS here, do not use the CSS name for filenames nor the app registry nor for anything with filepaths like /advertising/
  //* "ad_" needs to be added always even if it's Direct or Programmatic
  const newBlankFileNameForCSS = "ad_" + blankFilename; //* this fiexes the problem with CSS if the name starts with a number,
  console.log(
    `Utilities script, getBlankHTML(), find the value of blankFilename[${blankFilename}] prop. WE need to see if it needs "ad_" to fix CSS name issue`,
    `based on the filename[${blankFilename}] make a newCSSName[${newBlankFileNameForCSS}] for the html template. This fixes the issue where a newCSSName that starts with a number breaks when used as a CSS rulename.`
  );

  return `<!DOCTYPE html>
    <html>
    <head>
    <body class="adbodystyle">
        <div class="ad-sponsor ${newBlankFileNameForCSS}" data-widget-id="${newBlankFileNameForCSS}" data-version="0.1.5">
            <style>
                
                .${newBlankFileNameForCSS} {
                    position: absolute;
                    top: 0%;
                    left: 0%;
                    z-index: 14;
                    display:none;
                }
            </style>
        <script>
            common.methods.registerAdScript("${newBlankFileNameForCSS}",
                class extends baseAdTemplate {
                    constructor(parentElement) {
                        super(parentElement);
                    }
                    playContent() {
                    }
                });
        </script>
        </div>
    </body>
    </html>
    `;
}

export function getBlankManifest(blankFilename, partner) {
  //* we don't need to worry about the CSS rule name being a number here

  //* effectivly switches between either "blankFilename" or "partnerFolder/blankFilename"
  const filePathNameForProgOrDirect = partner
    ? partner.toLowerCase() + "/" + blankFilename
    : blankFilename;
  const ifPartner = partner ? partner.toLowerCase() + "/" : ""; //* add the "/" so that the extra folder level is handled in this logic

  console.log(
    `Utilities script, reference blankFilename[${blankFilename}] to add the partner folder, if there is one, which gives us: filePathNameForProgOrDirect[${filePathNameForProgOrDirect}].`
  );
  return `{
    "html": "advertising/${ifPartner}${blankFilename}.html",
    "fonts": [],
    "images": []
  }`;
}
